import React from 'react';
import './Header.css';


const Header = () => {
  return (
    <header className="header">
      <div className="logo-container">
      <div className="img">
              <img src="/logo.png" alt="Hyrex Logo" className="img"/>
      </div>
      <div className="logo">HYREX</div>
      </div>
      <div className="nav-buttons">
      <a href="https://forms.gle/oSVj6McSin95DnPU8" target="_blank" rel="noopener noreferrer" className="cta-btn">Join the client waitlist</a>
      </div>
    </header>
  );
}

export default Header;
